import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/machinecouponhis/list', qs.stringify(params))
}
//获取列表数据无分页
export const getlist = (params) => {
  return axios.post(root + '/set/machinecouponhis/getlist', qs.stringify(params))
}







// WEBPACK FOOTER //
// ./src/api/set/machinecouponhis.js